module.exports = __webpack_public_path__ + "img/team2.3513e28b.webp";